var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 V90 Q300,120 600,90 T1200,90 V0 Z",
    fill: "#0057a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDecoration);
export default __webpack_public_path__ + "static/media/footer-decoration.81c5660b7dfbfc778d5da938c7c9df91.svg";
export { ForwardRef as ReactComponent };